import * as fromDatatype from '../datatype-library';

export interface bl_inv_opdg_element_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    pdg_hdr_guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    unique_location_combination_guid: fromDatatype.GuidDataFieldInterface;
    unique_category_combination_guid: fromDatatype.GuidDataFieldInterface;
    location_hdr_guid: fromDatatype.GuidDataFieldInterface;
    brand_corner_boolean: fromDatatype.VarcharDatatypeInterface;
    qty_manual: fromDatatype.NumericDatatypeInterface;
    qty_ai: fromDatatype.NumericDatatypeInterface;
    qty_previous: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
}

export class bl_inv_opdg_element_RowClass implements bl_inv_opdg_element_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    pdg_hdr_guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    unique_location_combination_guid: fromDatatype.GuidDataFieldInterface;
    unique_category_combination_guid: fromDatatype.GuidDataFieldInterface;
    location_hdr_guid: fromDatatype.GuidDataFieldInterface;
    brand_corner_boolean: fromDatatype.VarcharDatatypeInterface;
    qty_manual: fromDatatype.NumericDatatypeInterface;
    qty_ai: fromDatatype.NumericDatatypeInterface;
    qty_previous: fromDatatype.NumericDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
}
